import { ConsultationStatus } from './ConsultationStatus.js';
import {
  mapDtoList,
  optionalEnum,
  requireNumber,
  requireObject,
  requireString,
} from './parse.js';

/**
 * Mirrors com.medprompt.consultation.ConsultationPreview
 *
 * @typedef {object} ConsultationPreviewData
 * @property {string} consultationId
 * @property {number} timestamp
 * @property {string|null} status
 */

/**
 * @param {object} raw
 * @returns {ConsultationPreviewData}
 */
export function fromConsultationPreviewData(raw) {
  const source = requireObject(raw, 'ConsultationPreview');
  return {
    consultationId: requireString(source, 'consultationId', 'ConsultationPreview'),
    timestamp: requireNumber(source, 'timestamp', 'ConsultationPreview'),
    status: optionalEnum(source.status, ConsultationStatus, 'ConsultationPreview', 'status'),
  };
}

/**
 * @param {unknown} raw
 * @returns {ConsultationPreviewData[]}
 */
export function fromConsultationPreviewDataList(raw) {
  return mapDtoList(raw, 'ConsultationPreview', fromConsultationPreviewData);
}
